// extracted by mini-css-extract-plugin
export var chip = "_d0-0";
export var filterDropdown = "_d0-5";
export var filterItem = "_d0-6";
export var icon = "_d0-1";
export var removeButton = "_d0-3";
export var removeIcon = "_d0-4";
export var separator = "_d0-2";